<div class="notifications__preview" (click)="displayListMobile.emit(false)">
  <wc-notification-center
    [config]="notificationCenterConfig"
    [isopen]="isShow"
    [showHeader]="showHeader"
    [defaultCategory]="defaultCategory"
    [activableNotifications]="activableNotifications"
    [channelId]="channelId"
    (read)="onNotificationClickHandler($event.detail)"
    (counterChange)="setCounter($event.detail)"
    (filterChanged)="onFilterChanged($event.detail)"
  ></wc-notification-center>
</div>
